/*
Author: Vinod
Date: 05/03//2020
Issue Description: Need to remove the red flash from Signin screen after session timeout.
search_string: PL_2904
*/
<template>
  <div>
    <!-- PL_2904 -->
    <idle-state v-if="isIdle && !isSignedOut " @onSignOut="(val)=>isSignedOut = val" />
    <div id="app2">
      <router-view></router-view>
      <saving-animation v-show="isSaving"></saving-animation>;
    </div>
  </div>
</template>

<script>
import SavingAnimation from "@/assets/animations/lottie/Saving";
import IdleState from "@/components/idle-state.vue";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      isSignedOut: true
    };
  },
  name: "App",
  components: {
    SavingAnimation,
    IdleState
  },
  mounted() {
    setTimeout(() => {
      this.isSignedOut = false;
    }, 1000);
  },
  computed: {
    isSaving() {
      return this.$root._data.isSaving;
    },
    isAuth() {
      return this.$store.getters.isAuth;
    },
    username() {
      return this.$store.getters.getUser;
    },
    ifGoogleSignIn() {
      return this.$store.getters.isGoogSignIn;
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle && localStorage.getItem("token");
    }
  },
  created() {},
  methods: {
    ...mapActions({
      act_signOut: "auth/signOut"
    }),

    signOut() {
        if (this.ifGoogleSignIn) {
          // gapi.auth2.getAuthInstance().signOut();
        }
        this.$store.commit("signOut", {
          googleSignOut: true
        });
        this.$router.push({
          name: "login"
        });
    },
    getIdleSessionTime() {
        this.lastActiveTime = new Date();
        window.onclick = function() {
          this.lastActiveTime = new Date();
        };
        window.onmousemove = function() {
          this.lastActiveTime = new Date();
        };
        window.onkeypress = function() {
          this.lastActiveTime = new Date();
        };
        window.onscroll = function() {
          this.lastActiveTime = new Date();
        };
        //let idleTimer_k = setInterval(() => this.CheckIdleTime(), 10000);
        //window.setInterval(this.CheckIdleTime(), 1000);
        //this.CheckIdleTime();
    },

    CheckIdleTime() {
        //returns idle time every 10 seconds
        let dateNowTime = new Date().getTime();
        let lastActiveTimeObject = this.getLastActiveDateObject();
        let lastActiveTime = new Date(lastActiveTimeObject).getTime();
        let remTime = Math.floor((dateNowTime - lastActiveTime) / 1000);
        // converting from milliseconds to seconds
    },

    getLastActiveDateObject() {
        window.onclick = function() {
          lastActiveTime = new Date();
        };
        window.onmousemove = function() {
          lastActiveTime = new Date();
        };
        window.onkeypress = function() {
          lastActiveTime = new Date();
        };
        window.onscroll = function() {
          lastActiveTime = new Date();
        };
        return lastActiveTime;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/base.scss";
@import "../src/scss/components/grid.css";
</style>

<style lang="scss" scoped>
#app2 {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #444444;
  width: 100%;
  /* background-color: #e6e6e6; */
}
.toolbar {
  background-color: #66b3ff;
  color: white;
}
.search {
  height: 36px;
}
.toolbar-items {
  height: 36px;
  padding: 4px;
}
.toolbar-el {
  margin-right: 5px;
}
</style>
